// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1puHh","title":"ClientCherryInfo_title__-BnkC","itemText":"ClientCherryInfo_itemText__2ESVf"};